export default function() {
    window.symetra =  window.symetra || {};
    window.symetra = {
        vars: {},
        init: function () {
            window.symetra.downloadForm.init();
            window.symetra.timeline.init();
        },

        downloadForm: {
            init: function () {
                $('.Box input[type=radio]').each(function () {
                    $(this).on("click", function () {
                        $(this).parent().parent().parent().find('.Box-panel').removeClass('is-active');
                        if (this.checked) {
                            $(this).parent().addClass('is-active');
                        }
                    });
                });
                $('.Expandable-link-tier').click(function (e) {
                    $('.Expandable-link-tier').removeClass('is-active');
                    e.preventDefault();
                    $(this).addClass('is-active');
                });
            }
        },
        timeline: {
            init: function () {
                var $timeline = $("#timeline-embed");

                if (!!$timeline && $timeline.length > 0) {
                    createStoryJS({
                        embed_id: 'timeline-embed',
                        type: 'timeline',
                        width: "100%",
                        height: "100%",
                        js: window.location.protocol + '//cdn.knightlab.com/libs/timeline/latest/js/timeline-min.js',
                        css: '/Assets/Styles/timeline.css',
                        source: { "timeline": timeline_data }
                    });
                }
            }
        }
    }

    $(function() {
        window.symetra.init();
    });
}



